(function ($) {
  $(window).on('load', function () {
    // run on DOM ready
    // grab target from URL hash (i.e. www.example.com/page-a.html#target-name)

    var target = window.location.hash;

    // only try to scroll to offset if target has been set in location hash
    // console.log(target);

    if (target != '') {
      var t = target.replace('#', '');
      var $target = $('a[id="'+t+'"]');
      // var $target = $('#Editorial-Daniel-Germann');

      if ($target.length) {
        $('html, body').animate({
            'scrollTop': $target.offset().top - ($('.header').outerHeight() + 30)
          }, // set offset value here i.e. 50
          900,
          'swing');
      }
    }
  });

})(jQuery);
